// @flow
import SMSIndicator from './SMSIndicator';

export default SMSIndicator;
